import styled from "styled-components/macro";

export const StyledParagraph = styled.p`
  white-space: pre-line;
  line-height: 1.5;
`;
